import { type FC } from "react";

import { StatusBadge } from "../../common/StatusBadge";
import {
  type BlackboardInstance,
  type WakeBlockBadgeCopy,
  getInstanceDisplayState,
} from "../blackboardModels";
import { mapStatus } from "./helpers";
import { WakeBlockedDetailsBlock } from "./WakeBlockedDetailsBlock";

// ---------------------------------------------------------------------------
// StatusSection — lifecycle status + wake-blocked details (when parked with
// unread input). The actor's "what is it doing right now" at a glance.
// ---------------------------------------------------------------------------

export const StatusSection: FC<{
  instance: BlackboardInstance;
  wakeBlockDetails: WakeBlockBadgeCopy | null;
}> = ({ instance, wakeBlockDetails }) => (
  <>
    <div className="flex items-start gap-4 px-4 py-3 transition-colors hover:bg-emerald-400/[0.02]">
      <p className="w-24 flex-shrink-0 font-mono text-[9px] font-bold uppercase tracking-[0.25em] text-emerald-700/80 dark:text-emerald-300/60">
        Status
      </p>
      <div className="min-w-0 flex-1">
        <StatusBadge
          status={mapStatus(instance.status)}
          label={getInstanceDisplayState(instance)}
        />
      </div>
    </div>
    {wakeBlockDetails && (
      <WakeBlockedDetailsBlock
        details={wakeBlockDetails}
        fullError={instance.wakeBlockedError}
        triggerChannelMessageId={instance.wakeBlockedTriggerChannelMessageId}
      />
    )}
  </>
);
